import { Field, Formik, FormikHelpers } from "formik";
import React from "react";
import { useHistory } from "react-router-dom";
import appService from "../../../services/app.service";
import { Loading } from "../../Loading";
import * as Yup from "yup";
import { IResidencePermit } from "../../../core/cm.types";
import { Input } from "../../fields/Input";
import { LocationAwareButton } from "../../LocationAwareButton";
import { useTranslation } from "react-i18next";
import { NoAdminAlert } from "../../NoAdminAlert"

const validationSchema = Yup.object().shape({
    title: Yup.string().required("*"),
});

export const ResidencePermitDetails: React.FunctionComponent<{
    id: string | undefined;
    isAdmin:boolean;
}> = (props) => {
    const { id,isAdmin } = props;
    const backButton = '/config/residencepermits';
    const { t } = useTranslation();
    const isNew = id === undefined || id === null;    
    const title = <h1 className="title is-3">{t("client:headers:tabResidencePermit")}</h1>
    const history = useHistory();
    const [data, setData] = React.useState<{
        isLoading: boolean;
        data: IResidencePermit;
    }>({
        isLoading: true,
        data: {},
    });
   
    React.useEffect(() => {
        const fetchData = async () => {
            const data = await appService.getResidencePermitsById(id);
            setData({
                isLoading: false,
                data: data,
            });
        };

        if (isNew) {
            setData({
                isLoading: false,
                data: {},
            });
        } else {
            fetchData();
        }
    }, []);

    const onSubmit = (
        values: Readonly<IResidencePermit | undefined>,
        formikHelpers: FormikHelpers<Readonly<IResidencePermit>>
    ) => {
        const data = values;

        const submit = async () => {
            if (data !== undefined && data !== null) {
                appService.saveResidencePermits(data).then((modulesResults) => {
                    var location = appService.getLocation();
                    history.push(`/${location}${backButton}`)
                }).catch(() => {
                    alert(t("client:common:errorOnSave"));
                });
            }
        };

        submit();
    };

    if (isAdmin !== true) { return <NoAdminAlert /> }

    return (
        <React.Fragment>
            <div className="section defaultSection">
                <Loading isLoading={data.isLoading}></Loading>
                {data.isLoading === false && (
                    <Formik
                        initialValues={data.data}
                        onSubmit={onSubmit}
                        validateOnMount={true}
                        validationSchema={validationSchema}
                        enableReinitialize
                    >
                        {({
                            values,
                            errors,
                            touched,
                            handleChange,
                            handleBlur,
                            handleSubmit,
                            isSubmitting,
                            isValid,
                            dirty,
                            setFieldValue,
                        }) => (
                                <React.Fragment>
                                    <form onSubmit={handleSubmit} className="form">
                                    <div className="columns">
                                            <div className="column">{title}</div>
                                            <div className="column button-header">
                                                    <button
                                                        type="submit"
                                                        className={`button is-link is-small is-pulled-right backAndSaveButton ${isSubmitting ? t("client:common:isLoading") : ""
                                                            }`}
                                                        disabled={isSubmitting || !dirty || !isValid}
                                                    >
                                                        {t("client:common:saveButton")}
                                                </button>
                                                <LocationAwareButton title={t("client:common:backButton")} className="button is-small is-pulled-right backAndSaveButton" relativeLocation={backButton}></LocationAwareButton>
                                            </div>
                                        </div>
                                        <Field
                                            name="title"
                                            label={t("client:common:columnTitle")}
                                            component={Input}
                                        />
                                        <Field
                                            name="description"
                                            label={t("client:common:description")}
                                            component={Input}
                                        />

                                        <div className="button-footer">
                                            <button
                                                type="submit"
                                                className={`button is-link is-small is-pulled-right backAndSaveButton ${isSubmitting ? t("client:common:isLoading") : ""
                                                }`}
                                                disabled={isSubmitting || !dirty || !isValid}
                                            >
                                                {t("client:common:saveButton")}
                                            </button>
                                            <LocationAwareButton title={t("client:common:backButton")} className="button is-small is-pulled-right backAndSaveButton" relativeLocation={backButton}></LocationAwareButton>
                                        </div>
                                    </form>
                                </React.Fragment>
                            )}
                    </Formik>
                )}
            </div>
        </React.Fragment>
    );
};
